export default __webpack_public_path__ + "static/media/mountains.86f71bbf.jpg";